<button mat-icon-button [matMenuTriggerFor]="appMenu">
  <img *ngIf="(auth.profile$ | async)?.extPhoto" mat-card-avatar [src]="(auth.profile$ | async)?.extPhoto" />
  <mat-icon *ngIf="!(auth.profile$ | async)?.extPhoto">account_circlet</mat-icon>
  <!-- Load Matcard CSS -->
  <mat-card style="display:none"></mat-card>
</button>
<mat-menu #appMenu="matMenu">
  <!-- <button mat-menu-item routerLink="/profile/edit">
    <mat-icon>edit</mat-icon>
    <span>Edit Profile</span>
  </button> -->
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>